
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.645 17.482c.935 0 1.638-.243 2.109-.729.47-.485.705-1.204.705-2.156V3.546c0-.952-.235-1.671-.705-2.157-.471-.485-1.174-.728-2.109-.728H3.07c-.93 0-1.63.241-2.104.724-.474.482-.71 1.202-.71 2.16v11.052c0 .958.236 1.679.71 2.161.474.483 1.175.724 2.104.724h10.575zm-.065-1.64H3.134c-.412 0-.73-.114-.955-.344-.224-.23-.336-.572-.336-1.026V3.67c0-.453.112-.795.336-1.025.225-.23.543-.345.955-.345H13.58c.412 0 .732.115.96.345.228.23.342.572.342 1.025v10.802c0 .454-.114.796-.342 1.026-.228.23-.547.345-.96.345zM7.416 13.36c.314 0 .563-.15.748-.45l3.968-6.431c.049-.096.097-.195.143-.297a.74.74 0 00.069-.307.636.636 0 00-.236-.513.794.794 0 00-.52-.196c-.26 0-.478.147-.656.44l-3.544 5.885-1.66-2.223a.982.982 0 00-.319-.283.758.758 0 00-.346-.081.68.68 0 00-.521.225.77.77 0 00-.208.541c0 .198.074.396.222.595L6.64 12.91c.117.16.237.275.36.345.123.07.261.105.415.105z","fill":"#108999"}})])
          )
        }
      }
    